import { render, staticRenderFns } from "./EditPricingView.vue?vue&type=template&id=2a2791dc&scoped=true"
import script from "./EditPricingView.vue?vue&type=script&lang=js"
export * from "./EditPricingView.vue?vue&type=script&lang=js"
import style0 from "./EditPricingView.vue?vue&type=style&index=0&id=2a2791dc&prod&lang=scss&scoped=true"
import style1 from "./EditPricingView.vue?vue&type=style&index=1&id=2a2791dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2791dc",
  null
  
)

export default component.exports